import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DragulaModule } from 'ng2-dragula';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgxBootstrapIconsModule } from 'ngx-bootstrap-icons';

import { NutritionMyIngredientPopupModule } from '../modal/nutrition-my-ingredient-popup/nutrition-my-ingredient-popup.module';
import { NutritionViewLeafModule } from '../nutrition-view-leaf/nutrition-view-leaf.module';
import { NutritionTreeViewNodeComponent } from './nutrition-tree-view-node.component';

@NgModule({
  declarations: [NutritionTreeViewNodeComponent],
  imports: [
    CommonModule,
    NgxBootstrapIconsModule,
    TooltipModule,
    DragulaModule,
    NutritionViewLeafModule,
    NutritionMyIngredientPopupModule,
  ],
  exports: [NutritionTreeViewNodeComponent],
})
export class NutritionTreeViewNodeModule {}
